import { z } from "zod";

export const diffLineTypeSchema = z.enum(["ADDED", "REMOVED", "CONTEXT"]);
export type DiffLineType = z.infer<typeof diffLineTypeSchema>;

export const diffLineSchema = z.object({
  type: diffLineTypeSchema,
  text: z.string(),
});
export type DiffLine = z.infer<typeof diffLineSchema>;

/** One run of changed lines with the surrounding unchanged context. */
export const diffHunkSchema = z.object({
  /** 1-based line number in the older version this hunk starts at. */
  fromLine: z.number().int().positive(),
  /** 1-based line number in the newer version this hunk starts at. */
  toLine: z.number().int().positive(),
  lines: z.array(diffLineSchema),
});
export type DiffHunk = z.infer<typeof diffHunkSchema>;

export const policyTextStatusSchema = z.enum([
  "AVAILABLE",
  "NO_TEXT",
  "NORMALIZATION_FAILED",
  "EXTRACTION_FAILED",
  "SOURCE_UNAVAILABLE",
]);
export type PolicyTextStatus = z.infer<typeof policyTextStatusSchema>;

export const policyVersionDiffSchema = z.object({
  fromVersion: z.number().int().positive(),
  toVersion: z.number().int().positive(),
  /** False when that version's document carries no extractable text. */
  fromTextAvailable: z.boolean(),
  toTextAvailable: z.boolean(),
  /** Why each side can or cannot participate in the text comparison. */
  fromTextStatus: policyTextStatusSchema,
  toTextStatus: policyTextStatusSchema,
  identical: z.boolean(),
  addedLines: z.number().int().nonnegative(),
  removedLines: z.number().int().nonnegative(),
  hunks: z.array(diffHunkSchema),
  /** True when hunks were capped to keep the response small. */
  truncated: z.boolean(),
});
export type PolicyVersionDiff = z.infer<typeof policyVersionDiffSchema>;
